// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    incidents: '/admin/iot-device/incidents',
    uploadFiles: '/admin/iot-device/incidents/upload-files',
    getUploadedFilesHistory: '/admin/iot-device/incidents/upload-files-history',
    getUploadedFileSignedURL: '/admin/iot-device/log-file',
    incidentsRoot: '/root/monitoring/incidents',
    uploadFilesRoot: '/root/monitoring/incidents/upload-files',
    getUploadedFilesHistoryRoot: '/root/monitoring/incidents/upload-files-history',
    getUploadedFileSignedURLRoot: '/root/monitoring/incidents/upload-files/signed-url',
};

const Create = (deviceId, payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.incidents}/${deviceId}`, payload).then(callback).catch(error).finally(next);
};

const Update = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.incidents}/${id}`, payload).then(callback).catch(error).finally(next);
};


const GetIncidents = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.incidents}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const Delete = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.incidents}/${id}`).then(callback).catch(error).finally(next);
};

const UploadFiles = (deviceId, payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.uploadFiles}/${deviceId}`, payload).then(callback).catch(error).finally(next);
};

const RemoveIncidentUploadFile = (id, incidentId, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.uploadFiles}/${incidentId}/${id}`).then(callback).catch(error).finally(next);
};

const GetUploadedFilesHistory = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getUploadedFilesHistory}/${id}`).then(callback).catch(error).finally(next);
};

const GetUploadedFileSignedURL = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getUploadedFileSignedURL}`, { params }).then(callback).catch(error).finally(next);
};



// root
const GetIncidentsRoot = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.incidentsRoot, { params }).then(callback).catch(error).finally(next);
};

const UpdateRoot = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.incidentsRoot}/${id}`, payload).then(callback).catch(error).finally(next);
};

const DeleteRoot = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.incidentsRoot}/${id}`).then(callback).catch(error).finally(next);
};

const UploadFilesRoot = (incidentId, payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.uploadFilesRoot}/${incidentId}`, payload).then(callback).catch(error).finally(next);
};

const RemoveIncidentUploadFileRoot = (id, incidentId, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.uploadFilesRoot}/${incidentId}/${id}`).then(callback).catch(error).finally(next);
};

const GetUploadedFilesHistoryRoot = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getUploadedFilesHistoryRoot}/${id}`).then(callback).catch(error).finally(next);
};


const GetUploadedFileSignedURLRoot = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getUploadedFileSignedURLRoot}`, { params }).then(callback).catch(error).finally(next);
};



export const IncidentsService = {
    Create,
    Update,
    GetIncidents,
    Delete,
    UploadFiles,
    RemoveIncidentUploadFile,
    GetUploadedFilesHistory,
    GetUploadedFileSignedURL,
};

export const IncidentsServiceRoot = {
    Update: UpdateRoot,
    GetIncidents: GetIncidentsRoot,
    Delete: DeleteRoot,
    RemoveIncidentUploadFile: RemoveIncidentUploadFileRoot,
    GetUploadedFilesHistory: GetUploadedFilesHistoryRoot,
    GetUploadedFileSignedURL: GetUploadedFileSignedURLRoot,
    UploadFiles: UploadFilesRoot,
};

